import FetchJson from "./fetchJson";
import store from "@/store";

export default class FetchHydra extends FetchJson {
  async call(path, options = {}) {
    // Fix for deleting elements in data list
    // message: data["hydra:title"] does not return exist in delete response
    // so the work around is just to resolve the promise
    // The caught error can be ignored
    // eslint-disable-next-line no-prototype-builtins
    if (options.hasOwnProperty("method") && options.method === "DELETE") {
      try {
        await super.call(path, options);
      } catch (e) {
        console.error(e);
        /**
         * TODO: Once we always receive Hydra responses from BE, we have to handle
         * hydra request errors here (format the error, instead of returning the error itself)
         */

        return Promise.reject(e);
      }

      return Promise.resolve();
    }

    try {
      let { status, data, headers } = await super.call(path, options);
      /**
       * Parse the guid
       */
      let getResourceWithId = resource => {
        let data = {
          ...resource,
        };

        if (resource["@id"]) {
          let id = resource["@id"];

          data.id = id.substring(id.lastIndexOf("/") + 1);
        }

        Object.keys(resource).forEach(p => {
          let value = resource[p];

          /**
           * Manage nested hydra object reference if applicable
           */

          // If field is broken,
          // skip it & report error
          if (data[p] == null) {
            console.error("data[p] is null", p, data[p]);

            return;
          }

          // Was bad array data response whit code example below
          // ? value.map((v) => getResourceWithId(v))
          // fixed with solution below
          // ? (data[p] = value)
          // comment was left here if in future there will be a problem

          if (Array.isArray(value)) {
            data[p] = value;
          } else if (typeof value === "object" && value["@id"]) {
            data[p] = getResourceWithId(value);
          } else {
            data[p] = value;
          }
        });

        return data;
      };

      /**
       * Get compatible response for Admin
       */
      if (data["hydra:member"]) {
        return Promise.resolve({
          status,
          data: data["hydra:member"].map(r => getResourceWithId(r)),
          total: data["hydra:totalItems"],
          headers,
        });
      }

      return Promise.resolve({
        status,
        data: getResourceWithId(data),
        headers,
      });
    } catch ({ status, message, data }) {
      /**
       * Call checkError the same way it is called in VA-admin every time an error occurs
       */
      store.dispatch(
        "auth/checkError",
        { status, message, data },
        {
          root: true,
        },
      );

      return Promise.reject({
        message,
        status,
        ...{
          message: data?.["hydra:title"],
          description: data?.["hydra:description"],
          errors: data?.violations
            ? data.violations.reduce(
                (o, error) => ({
                  ...o,
                  [error.propertyPath]: [...(o[error.propertyPath] || []), error.message],
                }),
                {},
              )
            : {},
        },
      });
    }
  }
}
